module.exports = __webpack_public_path__ + "2f4b89acc1f98c77fe6f32781ce58625.pdf";